import {
    HORSE_LIGHTBOX_OPEN,
    HORSE_LIGHTBOX_CLOSE,
    HORSE_LIGHTBOX_SET_INDEX,
} from '../constants/actionTypes';

const initialState = {
    isOpen: false,
    photoIndex: 0,
    images: [],
};

const horseLightboxReducer = (state = initialState, action) => {
    switch (action.type) {
    case HORSE_LIGHTBOX_OPEN:
        return {
            isOpen: true,
            images: action.images,
            photoIndex: 0,
        };
    case HORSE_LIGHTBOX_CLOSE:
        return initialState;
    case HORSE_LIGHTBOX_SET_INDEX:
        return {
            ...state,
            photoIndex: action.photoIndex,
        };
    default:
        return state;
    }
};

export const selectHorseLightbox = ({ horseLightbox }) => {
    return horseLightbox;
};

export default horseLightboxReducer;
